export const PWLESS_ACCESS = 'toast-customer-access'
export const PWLESS_REFRESH = 'toast-customer-refresh'
export const PW_ACCESS = 'toast-customermgmt-access'
export const REFRESH_COOKIE_EXPIRY_DAYS = 60
export const DEFAULT_AUTH_COOKIE_EXPIRY_DAYS = 1 / 48 // 30 mins
export const GUEST_HELP_URL =
  'https://guesthelp.toasttab.com/en/?utm_campaign=account_login_support'
